export const GET_CLIENTS_COMPANIES_SUCCESS = 'GET_CLIENTS_COMPANIES_SUCCESS';
